/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PersonDetails/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaProfileValueWithLabelText from 'DesignSystem/TysiaProfileElements/TysiaProfileValueWithLabelText/index'



/** @type {import('Simple/types.js').View} */
export default function PersonDetails({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/Detail/Content/PersonDetails"
  
}) {
let selectedLeadMetadataPersonFirstnameValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'lead.metadata.person.firstName',
})
let selectedLeadMetadataPersonLastnameValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'lead.metadata.person.lastName',
})
let selectedLeadMetadataPersonBirthdateValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'lead.metadata.person.birthDate',
format: fromFormat.dateISOIn,
})
let selectedLeadMetadataPersonEmailValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'lead.metadata.person.email',
})
let selectedLeadMetadataPersonPhonedetailsNumberValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'lead.metadata.person.phoneDetails.number',
})
let constantData = ' ('
let selectedLeadMetadataPersonPhonedetailsTypeValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'lead.metadata.person.phoneDetails.type',
})
let constantData1 = ')'
let aggregateData = fromHelpers.joinPhone(selectedLeadMetadataPersonPhonedetailsNumberValueData, constantData, selectedLeadMetadataPersonPhonedetailsTypeValueData, constantData1)
  return (<React.Fragment
>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="First Name"
 data="selected.lead.metadata.person.firstName"
 value={selectedLeadMetadataPersonFirstnameValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="Last Name"
 data="selected.lead.metadata.person.lastName"
 value={selectedLeadMetadataPersonLastnameValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="Date of Birth"
 data="selected.lead.metadata.person.birthDate"
 format="/Data/format.js dateISOIn"
 value={selectedLeadMetadataPersonBirthdateValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="Email"
 data="selected.lead.metadata.person.email"
 value={selectedLeadMetadataPersonEmailValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="Phone"
 data="selected.lead.metadata.person.phoneDetails.number"
 data="' ('"
 data="selected.lead.metadata.person.phoneDetails.type"
 data="')'"
 aggregate="helpers.js joinPhone"
 value={aggregateData}
/>
{children}
</React.Fragment>)
}